import { createSlice } from "@reduxjs/toolkit";
const acData = localStorage.getItem("acData");
const parsedACData = JSON.parse(acData);
const enrollementFilterSlice = createSlice({
  name: "header filter",
  initialState: {
    yearId: 11,
    regionType: 10, //21statewise //10 for all india
    regionCode: 99, // 11statewise //99 for all india
    dType: 10, //21statewise //10 for all india
    dCode: 99, // 11statewise //99 for all india
    dashboardRegionType: 10, //n
    dashboardRegionCode: "09", //100
    itemGroupId: 0,
  },

  reducers: {
    changeYearFilter(state, action) {
      state.yearId = action.payload;
    },
    changeDistrictFilter(state, action) {
      state.regionCode = action.payload;
    },
    changeStateFilter(state, action) {
      state.regionType = action.payload;
    },
    allFilter(state, action) {
      Object.assign(state, action.payload);
    },
  },
});

export const {
  changeYearFilter,
  changeDistrictFilter,
  changeStateFilter,
  allFilter,
} = enrollementFilterSlice.actions;
export default enrollementFilterSlice.reducer;
